import 'boxicons'

import './menu.js'
import './select_garage.js'
import './select_garage_mobile.js'
import './modules/slider.js'
import './modules/logos.js'
import './modules/avis.js'
import './modules/alert.js'
import './video.js'
import './map-search.js'
import './modules/mapgarage.js'
import './modules/accoridon.js'
import './scrollRDV.js'



// WEBPACK FOOTER //
// ./scripts/main.js